// Global packages and components
import { Roundal, Pill } from '~/components'

// Types
import type { RoundalProps } from '~/components/partials/common/roundal'

interface Props {
  tags: RoundalProps[]
  tagsType?: 'roundal' | 'pill'
}

const ProductTags = ({ tags, tagsType }: Props) => (
  <ul className="flex gap-0.5">
    {tags.map((tag, i) => (
      <li key={i}>
        {tagsType === 'pill' ? (
          <Pill
            {...tag}
            size="sm"
          />
        ) : (
          <Roundal
            {...tag}
            size="md"
          />
        )}
      </li>
    ))}
  </ul>
)

export default ProductTags
